import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DomainCard, SituationCard } from "../../../../components";
import { map } from "lodash";
import {
  Container,
  DomainCards,
  SituationsContainer,
} from "./styled-components";

const SituationsBloc = ({ data }: { data: Domain }) => {
  const [selectedDomainIndex, setSelectedDomainIndex] = useState<number>(0);
  const navigate = useNavigate();

  const handleClick = (index: number) => {
    selectedDomainIndex > 0
      ? setSelectedDomainIndex(0)
      : setSelectedDomainIndex(index + 1);
  };

  const isCardActive = useCallback(
    (index: number) => {
      if (selectedDomainIndex > 0) {
        if (selectedDomainIndex === index + 1) return false;
        return true;
      } else {
        return false;
      }
    },
    [selectedDomainIndex]
  );

  return (
    <Container>
      {data.situations &&
        map(data.situations, (situations, index: number) => {
          return (
            <DomainCards key={index}>
              <DomainCard
                title={situations.title}
                description={situations.subtitle}
                color={data.color.default}
                isActive={selectedDomainIndex === index + 1}
                onClick={() => handleClick(index)}
                disabled={isCardActive(index)}
              />
              {situations.exemples && (
                <SituationsContainer
                  isVisible={selectedDomainIndex === index + 1 ? true : false}
                >
                  {map(situations.exemples, (exemple, i) => {
                    return (
                      <SituationCard
                        key={i}
                        title={exemple.title}
                        description={exemple.description}
                        color={data.color.default}
                        onClick={() => {
                          if (exemple.preProcedure === true) {
                            navigate(
                              `/${
                                data.domain
                              }/demarches/${exemple.title.toLowerCase()}`
                            );
                          } else {
                            navigate(
                              `/${data.domain}/${exemple.title.toLowerCase()}`
                            );
                          }
                        }}
                      />
                    );
                  })}
                </SituationsContainer>
              )}
            </DomainCards>
          );
        })}
    </Container>
  );
};

export default SituationsBloc;
